var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("In deze stages zitten zometeen leerlingen zonder via dit label gekoppeld te zijn.")]),_vm._v(" "),_c('design-2021-apprentice-data-table',{attrs:{"items":_vm.tableData,"fields":_vm.studentFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }